var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-card",
    { staticClass: "mt-10 upload-log-section", class: { "is-open": _vm.open } },
    [
      _c(
        "md-card-actions",
        { attrs: { "md-alignment": "left" } },
        [
          _c(
            "md-button",
            {
              staticClass: "expand-button-size",
              attrs: { "aria-expanded": String(_vm.open) },
              on: {
                click: function($event) {
                  return _vm.$emit("toggle")
                }
              }
            },
            [
              _c("strong", { staticClass: "upper-word" }, [
                _vm._v(_vm._s(_vm.title))
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "upload-log-section__body",
          attrs: { "aria-hidden": String(!_vm.open) }
        },
        [
          _c(
            "div",
            { staticClass: "upload-log-section__inner" },
            [
              _c(
                "md-card-content",
                { staticClass: "card-content" },
                [_vm._t("default")],
                2
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-521dd3b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-521dd3b6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/community/UploadLogSection.vue
// module id = null
// module chunks = 